import { render, staticRenderFns } from "./OrganizadoresLista.vue?vue&type=template&id=39964bae&"
import script from "./OrganizadoresLista.vue?vue&type=script&lang=js&"
export * from "./OrganizadoresLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports